export interface LibraryKpi {
  id: string;
  label: string;
  value: number;
  delta: string;
  helperLine1: string;
  helperLine2: string;
}

// Static KPI content matching Figma (node 3589:89778/89791) — no backend endpoint exists yet.
export const LIBRARY_KPIS: LibraryKpi[] = [
  {
    id: "published-core-models",
    label: "Published Core Models",
    value: 27,
    delta: "+3 this month",
    helperLine1: "Provisional definition: count of production release models.",
    helperLine2: "Subject to standard Oil & Gas governance validations."
  },
  {
    id: "active-studio-initiatives",
    label: "Active Studio Initiatives",
    value: 12,
    delta: "Stable",
    helperLine1: "Provisional definition: current in-pipeline designs.",
    helperLine2: "Initiatives navigating through the 8 workflow phases."
  }
];

export type LibraryOntologyStatus = "Published" | "Active";

export interface LibraryOntologyRow {
  id: string;
  name: string;
  version: string;
  domainBusinessUnit: string;
  teamProject: string;
  lastUpdated: string;
  lifecycleStage: string;
  status: LibraryOntologyStatus;
}

export const LIBRARY_TABLE_COLUMNS = [
  "Ontology Name",
  "Version",
  "Domain / BU",
  "Team / Project",
  "Last Updated",
  "Lifecycle Stage",
  "Status",
  "Actions"
];

// No backend endpoint exists yet for the ontology library, so this stays as dummy/demo data.
export const PUBLISHED_ONTOLOGIES: LibraryOntologyRow[] = [
  {
    id: "1",
    name: "FPSO Asset Ontology",
    version: "v1.4.0",
    domainBusinessUnit: "Upstream Production",
    teamProject: "Sarah Jenkins (EY)",
    lastUpdated: "Today 08:32",
    lifecycleStage: "Validate & Release",
    status: "Published"
  },
  {
    id: "2",
    name: "Subsea Pipeline Integrity Model",
    version: "v2.1.2",
    domainBusinessUnit: "Pipeline Operations",
    teamProject: "David Miller (Client)",
    lastUpdated: "Yesterday",
    lifecycleStage: "Build Knowledge Graph",
    status: "Active"
  },
  {
    id: "3",
    name: "Equipment Reliability Model",
    version: "v1.0.8",
    domainBusinessUnit: "Maintenance & Reliability",
    teamProject: "Markus Vance (Client)",
    lastUpdated: "3 days ago",
    lifecycleStage: "Ground to Documents",
    status: "Published"
  },
  {
    id: "4",
    name: "Offshore Wind Structural Schema",
    version: "v0.4.1",
    domainBusinessUnit: "Renewables Integration",
    teamProject: "Elena Rostova (EY)",
    lastUpdated: "Oct 12, 2026",
    lifecycleStage: "Entities & Relationships",
    status: "Active"
  },
  {
    id: "5",
    name: "HSE Drilling Safety Vocabulary",
    version: "v3.0.0",
    domainBusinessUnit: "Well Operations",
    teamProject: "H. Sterling (EY)",
    lastUpdated: "Oct 02, 2026",
    lifecycleStage: "Validate & Release",
    status: "Published"
  }
];

export const PREVIOUSLY_CREATED_ONTOLOGIES: LibraryOntologyRow[] = [];
